import { useEffect } from "react"
import { useDispatch } from "react-redux"
import { useLocation } from "react-router-dom"
import { LocationState, Location } from 'history'
import { raisePushBreadcrumbProvider } from "@/actions/breadcrumbProvider"
import { BreadcrumbItem, BreadcrumbItemProvider } from "@/types/resource";


type RState = Location<LocationState>;

export const usePushBreadcrumb = (
  item: {label:string;path?:string}|((to: RState)=>BreadcrumbItem),
  toPatterns?: {
    toMatch?: string|((to: RState)=>boolean),
    toExclude?: string|((to: RState)=>boolean),
  }
) => {
  const location = useLocation()
  const dispatch = useDispatch()
  const {toMatch, toExclude} = toPatterns ?? {}
  useEffect(() => {
    const bcProvider: BreadcrumbItemProvider = {
      item: 
        typeof item === 'function' ? item
        : item.path ? item as BreadcrumbItem
        : { label: item.label, path: location.pathname},
      pathname: location.pathname,
      toMatch: toMatch ? toMatch : location.pathname,
      toExclude
    }
    dispatch(raisePushBreadcrumbProvider(bcProvider))
  }, [dispatch, item, location.pathname, toExclude, toMatch])
}
